// GA4 event names Releva can send server-side (Measurement Protocol), and the
// Releva activity that produces each. Must stay in sync with GA4_EVENT_NAMES in
// magellan-api (helpers/google/google-ga-event-dispatcher.js) — the admin API
// rejects any name outside that set with a 400.
//
// All are GA4 standard events except `subscribe`, which is a custom-named
// event (GA4 has no standard for a newsletter opt-in) — it appears in GA4 as a
// plain event the operator can mark as a key event.
//
// Deliberately absent, because neither can duplicate a gtag event and so
// neither is gated: `entered_campaign` / `entered_segment` (Releva-only, always
// sent) and `custom/*` events (Releva event names with no GA4 standard-event
// counterpart).
//
// `source` is what the event is sent for, shown under the picker so an operator
// can match it against what their own site already sends. It lives on the same
// entry as the name so the two cannot drift apart.
export const GA_TRACKING_EVENTS = [
  { value: 'view_item', source: 'a tracked product view' },
  { value: 'add_to_cart', source: 'products added to the cart' },
  { value: 'begin_checkout', source: 'a started checkout' },
  { value: 'add_payment_info', source: 'payment details entered at checkout' },
  { value: 'purchase', source: 'a completed order' },
  { value: 'add_to_wishlist', source: 'products added to the wishlist' },
  { value: 'search', source: 'an on-site search' },
  { value: 'sign_up', source: 'a new registration' },
  { value: 'subscribe', source: 'a newsletter subscribe captured by Releva' },
];

export const GA_TRACKING_EVENT_NAMES = GA_TRACKING_EVENTS.map((event) => event.value);
